import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { getOperationIndustrieStub } from '../../../../config/operations-industrie';

export default function MoteursHePage() {
  const parcours = getOperationIndustrieStub('moteurs-haute-efficacite');
  if (!parcours) return null;
  return (
    <AudienceParcoursStubPage
      parcours={parcours}
      audienceId="industrie"
      segment="operations"
      segmentLabel="Utilités & process"
      crossLinks={[
        {
          label: 'CEE IND-UT / IND-BA',
          href: '/industrie/aides/cee-ind',
          iconName: 'sparkles',
          hint: 'Primes énergie sur la fiche IND-UT-102',
        },
        {
          label: 'Variateurs de vitesse ventilation (fiche IND-UT-114)',
          href: '/industrie/operations/variateurs',
          iconName: 'zap',
          hint: 'Compléter par une variation électronique de vitesse',
        },
        {
          label: 'Audit NF EN 16247',
          href: '/industrie/operations/audit-reglementaire',
          iconName: 'file-search',
          hint: "Identifier les motorisations candidates",
        },
      ]}
      crossLinksAllLabel="Toutes les aides industrie"
      crossLinksAllHref="/industrie/aides"
    />
  );
}
